import { LOCATION_CHANGE } from 'connected-react-router';

// actions
import * as A from '../actions/propertyViewActions';

const initialState = {
  currentProperty: null,
  isSubmittingBid: false,
};

export const reducer = {
  propertyView(state = initialState, action) {
    switch (action.type) {
      case LOCATION_CHANGE:
      case A.clearState.type:
        return initialState;

      case A.getCurrentProperty.success:
        return { ...state, currentProperty: action.payload };

      case A.makeBet.type:
        return { ...state, isSubmittingBid: true };

      case A.makeBet.success:
      case A.makeBet.failure:
        return { ...state, isSubmittingBid: false };

      default:
        return state;
    }
  },
};
